import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";

function FilterRoute({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    name: "",
    start: "",
    end: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.name) {
      condition.name = {
        $regex: filter.name?.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.start) {
      condition.start = {
        $regex: filter.start?.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.end) {
      condition.end = {
        $regex: filter.end?.split(" ").join(".*"),
        $options: "i",
      };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Tên"
        placeholder="Tìm theo tên tuyến đường"
        value={filter.name}
        onSearch={(val) => setFilter({ ...filter, name: val })}
      />
      <FilterText
        label="Điểm đi"
        placeholder="Tìm theo điểm đi"
        value={filter.start}
        onSearch={(val) => setFilter({ ...filter, start: val })}
      />
      <FilterText
        label="Điểm đến"
        placeholder="Tìm theo điểm đến"
        value={filter.end}
        onSearch={(val) => setFilter({ ...filter, end: val })}
      />
    </WrapperFilter>
  );
}

export default FilterRoute;
